/**
 * Equipment labels - translates Swedish equipment strings to English
 * Equipment is stored in Swedish in the DB; this provides English display when language is 'en'
 */

import enEquipment from '../locales/en/equipment.json';
import { type Language } from '@/utils/languageUtils';

const equipmentEn = enEquipment as Record<string, string>;

/**
 * Get the localized equipment label. When language is 'en', returns English translation if available.
 * For 'sv' or unknown equipment, returns the original (Swedish) string.
 */
export const getEquipmentLabel = (svKey: string, lang?: Language): string => {
  if (lang === 'en' && equipmentEn[svKey]) {
    return equipmentEn[svKey];
  }
  return svKey;
};
